<mat-card class="form-box">
  <mat-card-content class="form-box__body">
    <ng-content></ng-content>
  </mat-card-content>
  <mat-card-actions class="form-box__footer" align="end">
    <ng-content select="[form-box-footer]"></ng-content>
  </mat-card-actions>
</mat-card>
